// Dashboard/app translations are lazy-loaded (see I18nContext) so they stay OUT of the
// public bundle. Do NOT import "@/i18n/dashboard" here.

export const LANGS = [
  { code: "fr", label: "Français", cc: "fr" },
  { code: "en", label: "English", cc: "gb" },
  { code: "es", label: "Español", cc: "es" },
  { code: "it", label: "Italiano", cc: "it" },
  { code: "de", label: "Deutsch", cc: "de" },
  { code: "nl", label: "Nederlands", cc: "nl" },
  { code: "sv", label: "Svenska", cc: "se" },
  { code: "da", label: "Dansk", cc: "dk" },
  { code: "bg", label: "Български", cc: "bg" },
  { code: "el", label: "Ελληνικά", cc: "gr" },
  { code: "hr", label: "Hrvatski", cc: "hr" },
  { code: "et", label: "Eesti", cc: "ee" },
  { code: "fi", label: "Suomi", cc: "fi" },
  { code: "hu", label: "Magyar", cc: "hu" },
  { code: "lv", label: "Latviešu", cc: "lv" },
  { code: "lt", label: "Lietuvių", cc: "lt" },
  { code: "pl", label: "Polski", cc: "pl" },
  { code: "pt", label: "Português", cc: "pt" },
  { code: "ro", label: "Română", cc: "ro" },
  { code: "sk", label: "Slovenčina", cc: "sk" },
  { code: "sl", label: "Slovenščina", cc: "si" },
  { code: "cs", label: "Čeština", cc: "cz" },
];
export const SUPPORTED = LANGS.map((l) => l.code);

const navKeys = {
  "fr": {
    "home": "Accueil",
    "elevage": "Mon élevage",
    "eggs": "Production d'œufs",
    "production": "Production",
    "reproduction": "Reproduction",
    "houses": "Poulaillers",
    "products": "Produits",
    "stock": "Stock",
    "orders": "Commandes",
    "customers": "Clients",
    "suppliers": "Fournisseurs",
    "expenses": "Dépenses",
    "accounting": "Comptabilité",
    "deliveries": "Livraisons",
    "shop": "Ma boutique",
    "stats": "Statistiques",
    "subscription": "Abonnement",
    "support": "Support",
    "settings": "Paramètres",
    "logout": "Déconnexion",
    "viewSite": "Voir le site",
    "notifications": "Notifications",
    "quickRecord": "Enregistrer la production"
  },
  "en": {
    "home": "Home",
    "elevage": "My flock",
    "eggs": "Egg production",
    "production": "Production",
    "reproduction": "Breeding",
    "houses": "Henhouses",
    "products": "Products",
    "stock": "Stock",
    "orders": "Orders",
    "customers": "Customers",
    "suppliers": "Suppliers",
    "expenses": "Expenses",
    "accounting": "Accounting",
    "deliveries": "Deliveries",
    "shop": "My shop",
    "stats": "Statistics",
    "subscription": "Subscription",
    "support": "Support",
    "settings": "Settings",
    "logout": "Log out",
    "viewSite": "View site",
    "notifications": "Notifications",
    "quickRecord": "Record production"
  },
  "es": {
    "home": "Inicio",
    "elevage": "Mi granja",
    "eggs": "Producción de huevos",
    "production": "Producción",
    "reproduction": "Reproducción",
    "houses": "Gallineros",
    "products": "Productos",
    "stock": "Inventario",
    "orders": "Pedidos",
    "customers": "Clientes",
    "suppliers": "Proveedores",
    "expenses": "Gastos",
    "accounting": "Contabilidad",
    "deliveries": "Entregas",
    "shop": "Mi tienda",
    "stats": "Estadísticas",
    "subscription": "Suscripción",
    "support": "Soporte",
    "settings": "Ajustes",
    "logout": "Cerrar sesión",
    "viewSite": "Ver el sitio",
    "notifications": "Notificaciones",
    "quickRecord": "Registrar producción"
  },
  "it": {
    "home": "Home",
    "elevage": "Il mio allevamento",
    "eggs": "Produzione di uova",
    "production": "Produzione",
    "reproduction": "Riproduzione",
    "houses": "Pollai",
    "products": "Prodotti",
    "stock": "Magazzino",
    "orders": "Ordini",
    "customers": "Clienti",
    "suppliers": "Fornitori",
    "expenses": "Spese",
    "accounting": "Contabilità",
    "deliveries": "Consegne",
    "shop": "Il mio negozio",
    "stats": "Statistiche",
    "subscription": "Abbonamento",
    "support": "Supporto",
    "settings": "Impostazioni",
    "logout": "Esci",
    "viewSite": "Vedi il sito",
    "notifications": "Notifiche",
    "quickRecord": "Registra produzione"
  },
  "de": {
    "home": "Startseite",
    "elevage": "Mein Bestand",
    "eggs": "Eierproduktion",
    "production": "Produktion",
    "reproduction": "Zucht",
    "houses": "Hühnerställe",
    "products": "Produkte",
    "stock": "Lager",
    "orders": "Bestellungen",
    "customers": "Kunden",
    "suppliers": "Lieferanten",
    "expenses": "Ausgaben",
    "accounting": "Buchhaltung",
    "deliveries": "Lieferungen",
    "shop": "Mein Shop",
    "stats": "Statistiken",
    "subscription": "Abonnement",
    "support": "Support",
    "settings": "Einstellungen",
    "logout": "Abmelden",
    "viewSite": "Zur Website",
    "notifications": "Benachrichtigungen",
    "quickRecord": "Produktion erfassen"
  },
  "nl": {
    "home": "Startpagina",
    "elevage": "Mijn veestapel",
    "eggs": "Eierproductie",
    "production": "Productie",
    "reproduction": "Reproductie",
    "houses": "Kippenhokken",
    "products": "Producten",
    "stock": "Voorraad",
    "orders": "Bestellingen",
    "customers": "Klanten",
    "suppliers": "Leveranciers",
    "expenses": "Uitgaven",
    "accounting": "Boekhouding",
    "deliveries": "Leveringen",
    "shop": "Mijn winkel",
    "stats": "Statistieken",
    "subscription": "Abonnement",
    "support": "Ondersteuning",
    "settings": "Instellingen",
    "logout": "Uitloggen",
    "viewSite": "Site bekijken",
    "notifications": "Meldingen",
    "quickRecord": "Productie opslaan"
  },
  "sv": {
    "home": "Hem",
    "elevage": "Min djurhållning",
    "eggs": "Äggproduktion",
    "production": "Produktion",
    "reproduction": "Reproduktion",
    "houses": "Hönshus",
    "products": "Produkter",
    "stock": "Lager",
    "orders": "Beställningar",
    "customers": "Kunder",
    "suppliers": "Leverantörer",
    "expenses": "Kostnader",
    "accounting": "Bokföring",
    "deliveries": "Leveranser",
    "shop": "Min butik",
    "stats": "Statistik",
    "subscription": "Prenumeration",
    "support": "Support",
    "settings": "Inställningar",
    "logout": "Logga ut",
    "viewSite": "Visa webbplatsen",
    "notifications": "Notifieringar",
    "quickRecord": "Registrera produktion"
  },
  "da": {
    "home": "Forside",
    "elevage": "Min besætning",
    "eggs": "Ægproduktion",
    "production": "Produktion",
    "reproduction": "Reproduktion",
    "houses": "Hønsehuse",
    "products": "Produkter",
    "stock": "Lager",
    "orders": "Ordrer",
    "customers": "Kunder",
    "suppliers": "Leverandører",
    "expenses": "Udgifter",
    "accounting": "Regnskab",
    "deliveries": "Leveringer",
    "shop": "Min butik",
    "stats": "Statistik",
    "subscription": "Abonnement",
    "support": "Support",
    "settings": "Indstillinger",
    "logout": "Log ud",
    "viewSite": "Se websted",
    "notifications": "Notifikationer",
    "quickRecord": "Registrer produktion"
  },
  "bg": {
    "home": "Начало",
    "elevage": "Моите животни",
    "eggs": "Производство на яйца",
    "production": "Производство",
    "reproduction": "Размножаване",
    "houses": "Кокошарници",
    "products": "Продукти",
    "stock": "Запаси",
    "orders": "Поръчки",
    "customers": "Клиенти",
    "suppliers": "Доставчици",
    "expenses": "Разходи",
    "accounting": "Счетоводство",
    "deliveries": "Доставки",
    "shop": "Моят магазин",
    "stats": "Статистика",
    "subscription": "Абонамент",
    "support": "Поддръжка",
    "settings": "Настройки",
    "logout": "Изход",
    "viewSite": "Виж сайта",
    "notifications": "Известия",
    "quickRecord": "Запиши производството"
  },
  "el": {
    "home": "Αρχική",
    "elevage": "Η εκτροφή μου",
    "eggs": "Παραγωγή αυγών",
    "production": "Παραγωγή",
    "reproduction": "Αναπαραγωγή",
    "houses": "Κοτέτσια",
    "products": "Προϊόντα",
    "stock": "Απόθεμα",
    "orders": "Παραγγελίες",
    "customers": "Πελάτες",
    "suppliers": "Προμηθευτές",
    "expenses": "Έξοδα",
    "accounting": "Λογιστική",
    "deliveries": "Παραδόσεις",
    "shop": "Το κατάστημά μου",
    "stats": "Στατιστικά",
    "subscription": "Συνδρομή",
    "support": "Υποστήριξη",
    "settings": "Ρυθμίσεις",
    "logout": "Αποσύνδεση",
    "viewSite": "Προβολή ιστότοπου",
    "notifications": "Ειδοποιήσεις",
    "quickRecord": "Καταχώρηση παραγωγής"
  },
  "hr": {
    "home": "Početna",
    "elevage": "Moj uzgoj",
    "eggs": "Proizvodnja jaja",
    "production": "Proizvodnja",
    "reproduction": "Reprodukcija",
    "houses": "Kokošinjci",
    "products": "Proizvodi",
    "stock": "Zaliha",
    "orders": "Narudžbe",
    "customers": "Kupci",
    "suppliers": "Dobavljači",
    "expenses": "Troškovi",
    "accounting": "Računovodstvo",
    "deliveries": "Dostave",
    "shop": "Moja trgovina",
    "stats": "Statistike",
    "subscription": "Pretplata",
    "support": "Podrška",
    "settings": "Postavke",
    "logout": "Odjava",
    "viewSite": "Pogledaj stranicu",
    "notifications": "Obavijesti",
    "quickRecord": "Evidentiraj proizvodnju"
  },
  "et": {
    "home": "Avaleht",
    "elevage": "Minu kasvatus",
    "eggs": "Munatoodang",
    "production": "Toodang",
    "reproduction": "Sigimine",
    "houses": "Kanalad",
    "products": "Tooted",
    "stock": "Laoseis",
    "orders": "Tellimused",
    "customers": "Kliendid",
    "suppliers": "Tarnijad",
    "expenses": "Kulud",
    "accounting": "Raamatupidamine",
    "deliveries": "Tarned",
    "shop": "Minu pood",
    "stats": "Statistika",
    "subscription": "Tellimus",
    "support": "Tugi",
    "settings": "Seaded",
    "logout": "Logi välja",
    "viewSite": "Vaata veebisaiti",
    "notifications": "Teavitused",
    "quickRecord": "Salvesta toodang"
  },
  "fi": {
    "home": "Etusivu",
    "elevage": "Eläimeni",
    "eggs": "Munantuotanto",
    "production": "Tuotanto",
    "reproduction": "Lisääntyminen",
    "houses": "Kanatalot",
    "products": "Tuotteet",
    "stock": "Varasto",
    "orders": "Tilaukset",
    "customers": "Asiakkaat",
    "suppliers": "Toimittajat",
    "expenses": "Kulut",
    "accounting": "Kirjanpito",
    "deliveries": "Toimitukset",
    "shop": "Kauppani",
    "stats": "Tilastot",
    "subscription": "Tilaus",
    "support": "Tuki",
    "settings": "Asetukset",
    "logout": "Kirjaudu ulos",
    "viewSite": "Näytä sivusto",
    "notifications": "Ilmoitukset",
    "quickRecord": "Kirjaa tuotanto"
  },
  "hu": {
    "home": "Főoldal",
    "elevage": "Tenyészetem",
    "eggs": "Tojástermelés",
    "production": "Termelés",
    "reproduction": "Szaporodás",
    "houses": "Baromfiólak",
    "products": "Termékek",
    "stock": "Készlet",
    "orders": "Rendelések",
    "customers": "Vevők",
    "suppliers": "Szállítók",
    "expenses": "Kiadások",
    "accounting": "Könyvelés",
    "deliveries": "Kiszállítások",
    "shop": "Boltom",
    "stats": "Statisztikák",
    "subscription": "Előfizetés",
    "support": "Támogatás",
    "settings": "Beállítások",
    "logout": "Kijelentkezés",
    "viewSite": "Webhely megtekintése",
    "notifications": "Értesítések",
    "quickRecord": "Termelés rögzítése"
  },
  "lv": {
    "home": "Sākums",
    "elevage": "Mana audzēšana",
    "eggs": "Olu ražošana",
    "production": "Ražošana",
    "reproduction": "Vairošanās",
    "houses": "Vistas mājas",
    "products": "Produkti",
    "stock": "Krājums",
    "orders": "Pasūtījumi",
    "customers": "Klienti",
    "suppliers": "Piegādātāji",
    "expenses": "Izdevumi",
    "accounting": "Grāmatvedība",
    "deliveries": "Piegādes",
    "shop": "Mans veikals",
    "stats": "Statistika",
    "subscription": "Abonements",
    "support": "Atbalsts",
    "settings": "Iestatījumi",
    "logout": "Izrakstīties",
    "viewSite": "Skatīt vietni",
    "notifications": "Paziņojumi",
    "quickRecord": "Reģistrēt ražošanu"
  },
  "lt": {
    "home": "Pagrindinis",
    "elevage": "Mano ūkis",
    "eggs": "Kiaušinių gamyba",
    "production": "Produkcija",
    "reproduction": "Reprodukcija",
    "houses": "Vištinynai",
    "products": "Produktai",
    "stock": "Atsargos",
    "orders": "Užsakymai",
    "customers": "Klientai",
    "suppliers": "Tiekėjai",
    "expenses": "Išlaidos",
    "accounting": "Apskaita",
    "deliveries": "Pristatymai",
    "shop": "Mano parduotuvė",
    "stats": "Statistika",
    "subscription": "Prenumerata",
    "support": "Pagalba",
    "settings": "Nustatymai",
    "logout": "Atsijungti",
    "viewSite": "Peržiūrėti svetainę",
    "notifications": "Pranešimai",
    "quickRecord": "Registruoti produkciją"
  },
  "pl": {
    "home": "Strona główna",
    "elevage": "Moja hodowla",
    "eggs": "Produkcja jaj",
    "production": "Produkcja",
    "reproduction": "Reprodukcja",
    "houses": "Kurniki",
    "products": "Produkty",
    "stock": "Stan",
    "orders": "Zamówienia",
    "customers": "Klienci",
    "suppliers": "Dostawcy",
    "expenses": "Wydatki",
    "accounting": "Księgowość",
    "deliveries": "Dostawy",
    "shop": "Mój sklep",
    "stats": "Statystyki",
    "subscription": "Subskrypcja",
    "support": "Wsparcie",
    "settings": "Ustawienia",
    "logout": "Wyloguj",
    "viewSite": "Zobacz stronę",
    "notifications": "Powiadomienia",
    "quickRecord": "Zapisz produkcję"
  },
  "pt": {
    "home": "Início",
    "elevage": "A minha criação",
    "eggs": "Produção de ovos",
    "production": "Produção",
    "reproduction": "Reprodução",
    "houses": "Galinheiros",
    "products": "Produtos",
    "stock": "Stock",
    "orders": "Encomendas",
    "customers": "Clientes",
    "suppliers": "Fornecedores",
    "expenses": "Despesas",
    "accounting": "Contabilidade",
    "deliveries": "Entregas",
    "shop": "A minha loja",
    "stats": "Estatísticas",
    "subscription": "Subscrição",
    "support": "Suporte",
    "settings": "Definições",
    "logout": "Sair",
    "viewSite": "Ver o site",
    "notifications": "Notificações",
    "quickRecord": "Registar a produção"
  },
  "ro": {
    "home": "Acasă",
    "elevage": "Crescătoria mea",
    "eggs": "Producție ouă",
    "production": "Producție",
    "reproduction": "Reproducere",
    "houses": "Găinare",
    "products": "Produse",
    "stock": "Stoc",
    "orders": "Comenzi",
    "customers": "Clienți",
    "suppliers": "Furnizori",
    "expenses": "Cheltuieli",
    "accounting": "Contabilitate",
    "deliveries": "Livrări",
    "shop": "Magazinul meu",
    "stats": "Statistici",
    "subscription": "Abonament",
    "support": "Suport",
    "settings": "Setări",
    "logout": "Deconectare",
    "viewSite": "Vezi site-ul",
    "notifications": "Notificări",
    "quickRecord": "Înregistrează producția"
  },
  "sk": {
    "home": "Domov",
    "elevage": "Môj chov",
    "eggs": "Produkcia vajec",
    "production": "Produkcia",
    "reproduction": "Reprodukcia",
    "houses": "Kurínky",
    "products": "Produkty",
    "stock": "Sklad",
    "orders": "Objednávky",
    "customers": "Zákazníci",
    "suppliers": "Dodávatelia",
    "expenses": "Výdavky",
    "accounting": "Účtovníctvo",
    "deliveries": "Doručenia",
    "shop": "Môj obchod",
    "stats": "Štatistiky",
    "subscription": "Predplatné",
    "support": "Podpora",
    "settings": "Nastavenia",
    "logout": "Odhlásiť sa",
    "viewSite": "Zobraziť stránku",
    "notifications": "Oznámenia",
    "quickRecord": "Zaznamenať produkciu"
  },
  "sl": {
    "home": "Domov",
    "elevage": "Moja reja",
    "eggs": "Proizvodnja jajc",
    "production": "Proizvodnja",
    "reproduction": "Razmnoževanje",
    "houses": "Kokošnjaki",
    "products": "Izdelki",
    "stock": "Zaloga",
    "orders": "Naročila",
    "customers": "Stranke",
    "suppliers": "Dobavitelji",
    "expenses": "Stroški",
    "accounting": "Računovodstvo",
    "deliveries": "Dostave",
    "shop": "Moja trgovina",
    "stats": "Statistika",
    "subscription": "Naročnina",
    "support": "Podpora",
    "settings": "Nastavitve",
    "logout": "Odjava",
    "viewSite": "Ogled spletnega mesta",
    "notifications": "Obvestila",
    "quickRecord": "Zabeleži proizvodnjo"
  },
  "cs": {
    "home": "Domů",
    "elevage": "Můj chov",
    "eggs": "Produkce vajec",
    "production": "Produkce",
    "reproduction": "Reprodukce",
    "houses": "Kurníky",
    "products": "Produkty",
    "stock": "Sklad",
    "orders": "Objednávky",
    "customers": "Zákazníci",
    "suppliers": "Dodavatelé",
    "expenses": "Výdaje",
    "accounting": "Účetnictví",
    "deliveries": "Doručení",
    "shop": "Můj obchod",
    "stats": "Statistiky",
    "subscription": "Předplatné",
    "support": "Podpora",
    "settings": "Nastavení",
    "logout": "Odhlásit se",
    "viewSite": "Zobrazit web",
    "notifications": "Oznámení",
    "quickRecord": "Zaznamenat produkci"
  }
};

const featuresData = {
  "fr": [
    [
      "Gestion de l'élevage",
      "Suivez tous vos animaux (volailles, chèvres, moutons, abeilles…) par lot."
    ],
    [
      "Suivi de production",
      "Œufs, lait, miel, portées… enregistrez votre production quotidienne en quelques secondes."
    ],
    [
      "Gestion des ventes",
      "Commandes, statuts et paiements centralisés."
    ],
    [
      "Boutique en ligne",
      "Une boutique publique automatique avec QR Code."
    ],
    [
      "Gestion des clients",
      "Un mini-CRM pour fidéliser vos acheteurs."
    ],
    [
      "Gestion des stocks",
      "Aliments, emballages et alertes de seuil minimum."
    ],
    [
      "Statistiques",
      "Production, chiffre d'affaires et bénéfice estimé."
    ],
    [
      "Application mobile",
      "Installable sur smartphone, utilisable sur le terrain."
    ]
  ],
  "en": [
    [
      "Livestock management",
      "Track all your animals (poultry, goats, sheep, bees…) by batch."
    ],
    [
      "Production tracking",
      "Eggs, milk, honey, litters… record your daily production in seconds."
    ],
    [
      "Sales management",
      "Orders, statuses and payments in one place."
    ],
    [
      "Online shop",
      "An automatic public shop with a QR code."
    ],
    [
      "Customer management",
      "A mini-CRM to build customer loyalty."
    ],
    [
      "Stock management",
      "Feed, packaging and low-threshold alerts."
    ],
    [
      "Statistics",
      "Production, revenue and estimated profit."
    ],
    [
      "Mobile app",
      "Installable on smartphone, usable in the field."
    ]
  ],
  "es": [
    [
      "Gestión del ganado",
      "Sigue todos tus animales (aves, cabras, ovejas, abejas…) por lote."
    ],
    [
      "Seguimiento de producción",
      "Huevos, leche, miel, camadas… registra tu producción diaria en segundos."
    ],
    [
      "Gestión de ventas",
      "Pedidos, estados y pagos centralizados."
    ],
    [
      "Tienda online",
      "Una tienda pública automática con código QR."
    ],
    [
      "Gestión de clientes",
      "Un mini-CRM para fidelizar a tus compradores."
    ],
    [
      "Gestión de inventario",
      "Piensos, embalajes y alertas de umbral mínimo."
    ],
    [
      "Estadísticas",
      "Producción, facturación y beneficio estimado."
    ],
    [
      "App móvil",
      "Instalable en el móvil, usable sobre el terreno."
    ]
  ],
  "it": [
    [
      "Gestione dell'allevamento",
      "Segui tutti i tuoi animali (pollame, capre, pecore, api…) per lotto."
    ],
    [
      "Monitoraggio produzione",
      "Uova, latte, miele, nidiate… registra la produzione giornaliera in pochi secondi."
    ],
    [
      "Gestione vendite",
      "Ordini, stati e pagamenti centralizzati."
    ],
    [
      "Negozio online",
      "Un negozio pubblico automatico con QR Code."
    ],
    [
      "Gestione clienti",
      "Un mini-CRM per fidelizzare i clienti."
    ],
    [
      "Gestione magazzino",
      "Mangimi, imballaggi e avvisi di soglia minima."
    ],
    [
      "Statistiche",
      "Produzione, fatturato e utile stimato."
    ],
    [
      "App mobile",
      "Installabile su smartphone, usabile sul campo."
    ]
  ],
  "de": [
    [
      "Bestandsverwaltung",
      "Verfolgen Sie alle Tiere (Geflügel, Ziegen, Schafe, Bienen…) pro Charge."
    ],
    [
      "Produktionsverfolgung",
      "Eier, Milch, Honig, Würfe… erfassen Sie Ihre Tagesproduktion in Sekunden."
    ],
    [
      "Verkaufsverwaltung",
      "Bestellungen, Status und Zahlungen zentral."
    ],
    [
      "Online-Shop",
      "Ein automatischer öffentlicher Shop mit QR-Code."
    ],
    [
      "Kundenverwaltung",
      "Ein Mini-CRM zur Kundenbindung."
    ],
    [
      "Lagerverwaltung",
      "Futter, Verpackung und Mindestbestand-Warnungen."
    ],
    [
      "Statistiken",
      "Produktion, Umsatz und geschätzter Gewinn."
    ],
    [
      "Mobile App",
      "Auf dem Smartphone installierbar, im Feld nutzbar."
    ]
  ],
  "nl": [
    [
      "Veestapelbeheer",
      "Volg al uw dieren (pluimvee, geiten, schapen, bijen…) per koppel."
    ],
    [
      "Productiebewaking",
      "Eieren, melk, honing, worpen… sla uw dagelijkse productie op in enkele seconden."
    ],
    [
      "Verkoopbeheer",
      "Bestellingen, statussen en betalingen centraal beheerd."
    ],
    [
      "Online winkel",
      "Een automatische publieke winkel met QR-code."
    ],
    [
      "Klantenbeheer",
      "Een mini-CRM om uw kopers te behouden."
    ],
    [
      "Voorraadbeheer",
      "Voer, verpakkingen en minimumdrempelwaarschuwingen."
    ],
    [
      "Statistieken",
      "Productie, omzet en geschatte winst."
    ],
    [
      "Mobiele app",
      "Installeerbaar op smartphone, bruikbaar in het veld."
    ]
  ],
  "sv": [
    [
      "Djurhantering",
      "Följ alla dina djur (fjäderfä, getter, får, bin…) per grupp."
    ],
    [
      "Produktionsuppföljning",
      "Ägg, mjölk, honung, kullar… registrera din dagliga produktion på några sekunder."
    ],
    [
      "Försäljningshantering",
      "Beställningar, statusar och betalningar samlade på ett ställe."
    ],
    [
      "Onlinebutik",
      "En automatisk publik butik med QR-kod."
    ],
    [
      "Kundhantering",
      "Ett mini-CRM för att behålla dina köpare."
    ],
    [
      "Lagerhantering",
      "Foder, förpackningar och larm för miniminivåer."
    ],
    [
      "Statistik",
      "Produktion, omsättning och beräknat resultat."
    ],
    [
      "Mobilapp",
      "Installerbar på smartphone, användbar i fält."
    ]
  ],
  "da": [
    [
      "Besætningsstyring",
      "Følg alle dine dyr (fjerkræ, geder, får, bier…) pr. hold."
    ],
    [
      "Produktionsopfølgning",
      "Æg, mælk, honning, kuld… registrer din daglige produktion på få sekunder."
    ],
    [
      "Salgsstyring",
      "Ordrer, statusser og betalinger samlet ét sted."
    ],
    [
      "Online butik",
      "En automatisk offentlig butik med QR-kode."
    ],
    [
      "Kundestyring",
      "Et mini-CRM til at fastholde dine kunder."
    ],
    [
      "Lagerstyring",
      "Foder, emballage og advarsler ved minimumslager."
    ],
    [
      "Statistik",
      "Produktion, omsætning og estimeret overskud."
    ],
    [
      "Mobilapp",
      "Kan installeres på smartphone og bruges i marken."
    ]
  ],
  "bg": [
    [
      "Управление на животновъдството",
      "Следете всички ваши животни (птици, кози, овце, пчели…) по партиди."
    ],
    [
      "Проследяване на производството",
      "Яйца, мляко, мед, приплоди… записвайте ежедневното производство за секунди."
    ],
    [
      "Управление на продажбите",
      "Поръчки, статуси и плащания на едно място."
    ],
    [
      "Онлайн магазин",
      "Автоматичен публичен магазин с QR код."
    ],
    [
      "Управление на клиентите",
      "Мини-CRM за задържане на купувачите."
    ],
    [
      "Управление на запасите",
      "Храна, опаковки и сигнали за минимален праг."
    ],
    [
      "Статистика",
      "Производство, приходи и очаквана печалба."
    ],
    [
      "Мобилно приложение",
      "Инсталируемо на смартфон, използваемо на терен."
    ]
  ],
  "el": [
    [
      "Διαχείριση εκτροφής",
      "Παρακολουθήστε όλα τα ζώα σας (πτηνά, κατσίκες, πρόβατα, μέλισσες…) ανά παρτίδα."
    ],
    [
      "Παρακολούθηση παραγωγής",
      "Αυγά, γάλα, μέλι, γέννες… καταχωρήστε την καθημερινή παραγωγή σε δευτερόλεπτα."
    ],
    [
      "Διαχείριση πωλήσεων",
      "Παραγγελίες, καταστάσεις και πληρωμές σε ένα σημείο."
    ],
    [
      "Διαδικτυακό κατάστημα",
      "Αυτόματο δημόσιο κατάστημα με QR Code."
    ],
    [
      "Διαχείριση πελατών",
      "Ένα mini-CRM για να κρατάτε τους αγοραστές σας κοντά."
    ],
    [
      "Διαχείριση αποθέματος",
      "Τροφές, συσκευασίες και ειδοποιήσεις ελάχιστου ορίου."
    ],
    [
      "Στατιστικά",
      "Παραγωγή, κύκλος εργασιών και εκτιμώμενο κέρδος."
    ],
    [
      "Εφαρμογή κινητού",
      "Εγκαταστάσιμη σε smartphone, χρήσιμη στο χωράφι."
    ]
  ],
  "hr": [
    [
      "Upravljanje uzgojem",
      "Pratite sve svoje životinje (perad, koze, ovce, pčele…) po grupama."
    ],
    [
      "Praćenje proizvodnje",
      "Jaja, mlijeko, med, leglo… evidentirajte svoju dnevnu proizvodnju za nekoliko sekundi."
    ],
    [
      "Upravljanje prodajom",
      "Narudžbe, statusi i plaćanja na jednom mjestu."
    ],
    [
      "Online trgovina",
      "Automatska javna trgovina s QR kodom."
    ],
    [
      "Upravljanje kupcima",
      "Mini-CRM za vjernost vaših kupaca."
    ],
    [
      "Upravljanje zalihama",
      "Hrana, ambalaža i upozorenja minimalnih razina."
    ],
    [
      "Statistike",
      "Proizvodnja, prihod i procijenjeni profit."
    ],
    [
      "Mobilna aplikacija",
      "Instalabilna na pametni telefon, upotrebljiva na terenu."
    ]
  ],
  "et": [
    [
      "Kasvatuse haldamine",
      "Jälgige kõiki loomi (linnud, kitsed, lambad, mesilased…) partii kaupa."
    ],
    [
      "Toodangu jälgimine",
      "Munad, piim, mesi, pesakonnad… salvestage oma päevane toodang mõne sekundiga."
    ],
    [
      "Müügihaldus",
      "Tellimused, olekud ja maksed ühes kohas."
    ],
    [
      "Veebipood",
      "Automaatne avalik pood QR-koodiga."
    ],
    [
      "Kliendihaldus",
      "Mini-CRM ostjate hoidmiseks."
    ],
    [
      "Laohaldus",
      "Sööt, pakendid ja minimaalsete varude hoiatused."
    ],
    [
      "Statistika",
      "Toodang, käive ja hinnanguline kasum."
    ],
    [
      "Mobiilirakendus",
      "Installeeritav nutitelefoni, kasutatav põllul."
    ]
  ],
  "fi": [
    [
      "Eläinten hallinta",
      "Seuraa kaikkia eläimiäsi (siipikarjaa, vuohia, lampaita, mehiläisiä…) parvittain."
    ],
    [
      "Tuotannon seuranta",
      "Munat, maito, hunaja, pentueet… kirjaa päivittäinen tuotantosi muutamassa sekunnissa."
    ],
    [
      "Myynnin hallinta",
      "Tilaukset, tilat ja maksut keskitetysti."
    ],
    [
      "Verkkokauppa",
      "Automaattinen julkinen kauppa QR-koodilla."
    ],
    [
      "Asiakashallinta",
      "Mini-CRM ostajien sitouttamiseen."
    ],
    [
      "Varastonhallinta",
      "Rehut, pakkaukset ja vähimmäisrajahälytykset."
    ],
    [
      "Tilastot",
      "Tuotanto, liikevaihto ja arvioitu tulos."
    ],
    [
      "Mobiilisovellus",
      "Asennettavissa älypuhelimelle, käytettävissä pellolla."
    ]
  ],
  "hu": [
    [
      "Állomány-kezelés",
      "Kövesse nyomon összes állatát (baromfi, kecske, juh, méhek…) tételenként."
    ],
    [
      "Termeléskövetés",
      "Tojás, tej, méz, almok… rögzítse napi termelését másodpercek alatt."
    ],
    [
      "Értékesítés-kezelés",
      "Rendelések, státuszok és fizetések egy helyen."
    ],
    [
      "Online bolt",
      "Automatikus nyilvános bolt QR-kóddal."
    ],
    [
      "Vevőkezelés",
      "Mini CRM a vásárlói hűség növeléséhez."
    ],
    [
      "Készletkezelés",
      "Takarmány, csomagolóanyag és minimális készletriasztások."
    ],
    [
      "Statisztikák",
      "Termelés, bevétel és becsült nyereség."
    ],
    [
      "Mobilalkalmazás",
      "Okostelefonra telepíthető, terepen is használható."
    ]
  ],
  "lv": [
    [
      "Audzēšanas pārvaldība",
      "Sekojiet visiem saviem dzīvniekiem (mājputni, kazas, aitas, bites…) pa grupām."
    ],
    [
      "Ražošanas uzskaite",
      "Olas, piens, medus, metienu… reģistrējiet ikdienas ražošanu dažās sekundēs."
    ],
    [
      "Pārdošanas pārvaldība",
      "Pasūtījumi, statusi un maksājumi vienuviet."
    ],
    [
      "Tiešsaistes veikals",
      "Automātisks publisks veikals ar QR kodu."
    ],
    [
      "Klientu pārvaldība",
      "Mini-CRM jūsu pircēju lojalitātei."
    ],
    [
      "Krājumu pārvaldība",
      "Barība, iepakojums un minimālā sliekšņa brīdinājumi."
    ],
    [
      "Statistika",
      "Ražošana, apgrozījums un aprēķinātā peļņa."
    ],
    [
      "Mobilā lietotne",
      "Instalējama viedtālrunī, lietojama laukā."
    ]
  ],
  "lt": [
    [
      "Ūkio valdymas",
      "Sekite visus gyvūnus (paukščius, ožkas, avis, bites…) pagal partijas."
    ],
    [
      "Gamybos sekimas",
      "Kiaušiniai, pienas, medus, jaunikliai… registruokite dienos produkciją per kelias sekundes."
    ],
    [
      "Pardavimų valdymas",
      "Užsakymai, statusai ir mokėjimai vienoje vietoje."
    ],
    [
      "Internetinė parduotuvė",
      "Automatinė viešoji parduotuvė su QR kodu."
    ],
    [
      "Klientų valdymas",
      "Mini CRM, padedantis išlaikyti pirkėjus."
    ],
    [
      "Atsargų valdymas",
      "Pašarai, pakuotės ir minimalaus lygio įspėjimai."
    ],
    [
      "Statistika",
      "Gamyba, apyvarta ir numatomas pelnas."
    ],
    [
      "Mobilioji programa",
      "Diegiama išmaniajame telefone, naudojama lauke."
    ]
  ],
  "pl": [
    [
      "Zarządzanie hodowlą",
      "Śledź wszystkie zwierzęta (drób, kozy, owce, pszczoły…) według partii."
    ],
    [
      "Śledzenie produkcji",
      "Jaja, mleko, miód, mioty… zapisuj codzienną produkcję w kilka sekund."
    ],
    [
      "Zarządzanie sprzedażą",
      "Zamówienia, statusy i płatności w jednym miejscu."
    ],
    [
      "Sklep internetowy",
      "Automatyczny sklep publiczny z kodem QR."
    ],
    [
      "Zarządzanie klientami",
      "Mini-CRM do budowania lojalności kupujących."
    ],
    [
      "Zarządzanie zapasami",
      "Pasza, opakowania i alerty minimalnego stanu."
    ],
    [
      "Statystyki",
      "Produkcja, przychód i szacowany zysk."
    ],
    [
      "Aplikacja mobilna",
      "Instalowana na smartfonie, używana w terenie."
    ]
  ],
  "pt": [
    [
      "Gestão da criação",
      "Acompanhe todos os seus animais (aves, cabras, ovelhas, abelhas…) por lote."
    ],
    [
      "Acompanhamento da produção",
      "Ovos, leite, mel, ninhadas… registe a sua produção diária em poucos segundos."
    ],
    [
      "Gestão de vendas",
      "Encomendas, estados e pagamentos centralizados."
    ],
    [
      "Loja online",
      "Uma loja pública automática com QR Code."
    ],
    [
      "Gestão de clientes",
      "Um mini-CRM para fidelizar os seus compradores."
    ],
    [
      "Gestão de stocks",
      "Alimentos, embalagens e alertas de limiar mínimo."
    ],
    [
      "Estatísticas",
      "Produção, volume de negócios e lucro estimado."
    ],
    [
      "Aplicação móvel",
      "Instalável em smartphone, utilizável no terreno."
    ]
  ],
  "ro": [
    [
      "Gestionarea crescătoriei",
      "Urmăriți toate animalele (păsări, capre, oi, albine…) pe loturi."
    ],
    [
      "Urmărirea producției",
      "Ouă, lapte, miere, litiere… înregistrați producția zilnică în câteva secunde."
    ],
    [
      "Gestionarea vânzărilor",
      "Comenzi, statusuri și plăți centralizate."
    ],
    [
      "Magazin online",
      "Un magazin public automat cu Cod QR."
    ],
    [
      "Gestionarea clienților",
      "Un mini-CRM pentru fidelizarea cumpărătorilor."
    ],
    [
      "Gestionarea stocurilor",
      "Alimente, ambalaje și alerte de prag minim."
    ],
    [
      "Statistici",
      "Producție, cifră de afaceri și profit estimat."
    ],
    [
      "Aplicație mobilă",
      "Instalabilă pe smartphone, utilizabilă pe teren."
    ]
  ],
  "sk": [
    [
      "Správa chovu",
      "Sledujte všetky zvieratá (hydina, kozy, ovce, včely…) po skupinách."
    ],
    [
      "Sledovanie produkcie",
      "Vajcia, mlieko, med, vrhy… zaznamenajte dennú produkciu za pár sekúnd."
    ],
    [
      "Správa predaja",
      "Objednávky, stavy a platby na jednom mieste."
    ],
    [
      "Online obchod",
      "Automatický verejný obchod s QR kódom."
    ],
    [
      "Správa zákazníkov",
      "Mini-CRM pre vernosť vašich kupujúcich."
    ],
    [
      "Správa skladu",
      "Krmivo, obaly a upozornenia na minimálnu zásobu."
    ],
    [
      "Štatistiky",
      "Produkcia, tržby a odhadovaný zisk."
    ],
    [
      "Mobilná aplikácia",
      "Inštalovateľná na smartfón, použiteľná v teréne."
    ]
  ],
  "sl": [
    [
      "Upravljanje reje",
      "Sledite vsem svojim živalim (perutnina, koze, ovce, čebele…) po jatah."
    ],
    [
      "Sledenje proizvodnji",
      "Jajca, mleko, med, legla… zabeležite dnevno proizvodnjo v nekaj sekundah."
    ],
    [
      "Upravljanje prodaje",
      "Naročila, statusi in plačila na enem mestu."
    ],
    [
      "Spletna trgovina",
      "Samodejno javna trgovina s QR kodo."
    ],
    [
      "Upravljanje strank",
      "Mini-CRM za zvestobo kupcev."
    ],
    [
      "Upravljanje zalog",
      "Krma, embalaža in opozorila o minimalnih zalogah."
    ],
    [
      "Statistika",
      "Proizvodnja, prihodki in ocenjeni dobiček."
    ],
    [
      "Mobilna aplikacija",
      "Namestitvena na pametni telefon, uporabna na terenu."
    ]
  ],
  "cs": [
    [
      "Správa chovu",
      "Sledujte všechna svá zvířata (drůbež, kozy, ovce, včely…) po skupinách."
    ],
    [
      "Sledování produkce",
      "Vejce, mléko, med, vrhy… zaznamenejte denní produkci během několika sekund."
    ],
    [
      "Správa prodeje",
      "Objednávky, stavy a platby na jednom místě."
    ],
    [
      "Online obchod",
      "Automatický veřejný obchod s QR kódem."
    ],
    [
      "Správa zákazníků",
      "Mini-CRM pro udržení věrnosti vašich kupujících."
    ],
    [
      "Správa skladu",
      "Krmivo, obaly a upozornění na minimální zásoby."
    ],
    [
      "Statistiky",
      "Produkce, tržby a odhadovaný zisk."
    ],
    [
      "Mobilní aplikace",
      "Instalovatelná na smartphone, použitelná v terénu."
    ]
  ]
};

const plansData = {
  "fr": [
    [
      "free",
      "Gratuit",
      [
        "Gestion basique",
        "Gestion des animaux",
        "Production d'œufs",
        "Jusqu'à 5 produits"
      ]
    ],
    [
      "essential",
      "Essentiel",
      [
        "Toutes les fonctions de gestion",
        "Boutique en ligne",
        "Gestion des commandes",
        "Gestion des clients",
        "Produits illimités"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Tout Essentiel",
        "Statistiques avancées",
        "Notifications",
        "Gestion des livraisons",
        "Plusieurs utilisateurs",
        "Export des données"
      ]
    ]
  ],
  "en": [
    [
      "free",
      "Free",
      [
        "Basic management",
        "Animal management",
        "Egg production",
        "Up to 5 products"
      ]
    ],
    [
      "essential",
      "Essential",
      [
        "All management features",
        "Online shop",
        "Order management",
        "Customer management",
        "Unlimited products"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Everything in Essential",
        "Advanced statistics",
        "Notifications",
        "Delivery management",
        "Multiple users",
        "Data export"
      ]
    ]
  ],
  "es": [
    [
      "free",
      "Gratis",
      [
        "Gestión básica",
        "Gestión de animales",
        "Producción de huevos",
        "Hasta 5 productos"
      ]
    ],
    [
      "essential",
      "Esencial",
      [
        "Todas las funciones de gestión",
        "Tienda online",
        "Gestión de pedidos",
        "Gestión de clientes",
        "Productos ilimitados"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Todo lo de Esencial",
        "Estadísticas avanzadas",
        "Notificaciones",
        "Gestión de entregas",
        "Varios usuarios",
        "Exportación de datos"
      ]
    ]
  ],
  "it": [
    [
      "free",
      "Gratuito",
      [
        "Gestione base",
        "Gestione animali",
        "Produzione di uova",
        "Fino a 5 prodotti"
      ]
    ],
    [
      "essential",
      "Essenziale",
      [
        "Tutte le funzioni di gestione",
        "Negozio online",
        "Gestione ordini",
        "Gestione clienti",
        "Prodotti illimitati"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Tutto Essenziale",
        "Statistiche avanzate",
        "Notifiche",
        "Gestione consegne",
        "Più utenti",
        "Esportazione dati"
      ]
    ]
  ],
  "de": [
    [
      "free",
      "Kostenlos",
      [
        "Basisverwaltung",
        "Tierverwaltung",
        "Eierproduktion",
        "Bis zu 5 Produkte"
      ]
    ],
    [
      "essential",
      "Essential",
      [
        "Alle Verwaltungsfunktionen",
        "Online-Shop",
        "Bestellverwaltung",
        "Kundenverwaltung",
        "Unbegrenzte Produkte"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Alles aus Essential",
        "Erweiterte Statistiken",
        "Benachrichtigungen",
        "Lieferverwaltung",
        "Mehrere Benutzer",
        "Datenexport"
      ]
    ]
  ],
  "nl": [
    [
      "free",
      "Gratis",
      [
        "Basisbeheer",
        "Dierbeheer",
        "Eierproductie",
        "Tot 5 producten"
      ]
    ],
    [
      "essential",
      "Essentieel",
      [
        "Alle beheerfuncties",
        "Online winkel",
        "Bestellingenbeheer",
        "Klantenbeheer",
        "Onbeperkte producten"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Alles van Essentieel",
        "Geavanceerde statistieken",
        "Meldingen",
        "Leveringenbeheer",
        "Meerdere gebruikers",
        "Gegevensexport"
      ]
    ]
  ],
  "sv": [
    [
      "free",
      "Gratis",
      [
        "Grundläggande hantering",
        "Djurhantering",
        "Äggproduktion",
        "Upp till 5 produkter"
      ]
    ],
    [
      "essential",
      "Väsentlig",
      [
        "Alla hanteringsfunktioner",
        "Onlinebutik",
        "Beställningshantering",
        "Kundhantering",
        "Obegränsade produkter"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Allt i Väsentlig",
        "Avancerad statistik",
        "Notifieringar",
        "Leveranshantering",
        "Flera användare",
        "Dataexport"
      ]
    ]
  ],
  "da": [
    [
      "free",
      "Gratis",
      [
        "Grundlæggende styring",
        "Dyrestyring",
        "Ægproduktion",
        "Op til 5 produkter"
      ]
    ],
    [
      "essential",
      "Essentiel",
      [
        "Alle styringsfunktioner",
        "Online butik",
        "Ordrestyring",
        "Kundestyring",
        "Ubegrænsede produkter"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Alt i Essentiel",
        "Avanceret statistik",
        "Notifikationer",
        "Leveringsstyring",
        "Flere brugere",
        "Dataeksport"
      ]
    ]
  ],
  "bg": [
    [
      "free",
      "Безплатен",
      [
        "Основно управление",
        "Управление на животните",
        "Производство на яйца",
        "До 5 продукта"
      ]
    ],
    [
      "essential",
      "Есенциален",
      [
        "Всички функции за управление",
        "Онлайн магазин",
        "Управление на поръчки",
        "Управление на клиенти",
        "Неограничени продукти"
      ]
    ],
    [
      "pro",
      "Про",
      [
        "Всичко от Есенциален",
        "Разширена статистика",
        "Известия",
        "Управление на доставки",
        "Множество потребители",
        "Експорт на данни"
      ]
    ]
  ],
  "el": [
    [
      "free",
      "Δωρεάν",
      [
        "Βασική διαχείριση",
        "Διαχείριση ζώων",
        "Παραγωγή αυγών",
        "Έως 5 προϊόντα"
      ]
    ],
    [
      "essential",
      "Βασικό",
      [
        "Όλες οι λειτουργίες διαχείρισης",
        "Διαδικτυακό κατάστημα",
        "Διαχείριση παραγγελιών",
        "Διαχείριση πελατών",
        "Απεριόριστα προϊόντα"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Όλα του Βασικού",
        "Προηγμένα στατιστικά",
        "Ειδοποιήσεις",
        "Διαχείριση παραδόσεων",
        "Πολλαπλοί χρήστες",
        "Εξαγωγή δεδομένων"
      ]
    ]
  ],
  "hr": [
    [
      "free",
      "Besplatno",
      [
        "Osnovno upravljanje",
        "Upravljanje životinjama",
        "Proizvodnja jaja",
        "Do 5 proizvoda"
      ]
    ],
    [
      "essential",
      "Osnovno",
      [
        "Sve funkcije upravljanja",
        "Online trgovina",
        "Upravljanje narudžbama",
        "Upravljanje kupcima",
        "Neograničeni proizvodi"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Sve iz Osnovnog",
        "Napredne statistike",
        "Obavijesti",
        "Upravljanje dostavama",
        "Više korisnika",
        "Izvoz podataka"
      ]
    ]
  ],
  "et": [
    [
      "free",
      "Tasuta",
      [
        "Põhihaldus",
        "Loomade haldus",
        "Munatoodang",
        "Kuni 5 toodet"
      ]
    ],
    [
      "essential",
      "Esmaklassiline",
      [
        "Kõik haldusfunktsioonid",
        "Veebipood",
        "Tellimuste haldus",
        "Kliendihaldus",
        "Piiramatu arv tooteid"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Kõik esmaklassilisest",
        "Täiustatud statistika",
        "Teavitused",
        "Tarnetehaldus",
        "Mitu kasutajat",
        "Andmete eksport"
      ]
    ]
  ],
  "fi": [
    [
      "free",
      "Ilmainen",
      [
        "Perushallinta",
        "Eläinten hallinta",
        "Munantuotanto",
        "Enintään 5 tuotetta"
      ]
    ],
    [
      "essential",
      "Perus",
      [
        "Kaikki hallintatoiminnot",
        "Verkkokauppa",
        "Tilaustenhallinta",
        "Asiakashallinta",
        "Rajattomat tuotteet"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Kaikki Perus-toiminnot",
        "Edistyneet tilastot",
        "Ilmoitukset",
        "Toimitusten hallinta",
        "Useita käyttäjiä",
        "Tietojen vienti"
      ]
    ]
  ],
  "hu": [
    [
      "free",
      "Ingyenes",
      [
        "Alapkezelés",
        "Állatkezelés",
        "Tojástermelés",
        "Legfeljebb 5 termék"
      ]
    ],
    [
      "essential",
      "Alapcsomag",
      [
        "Összes kezelési funkció",
        "Online bolt",
        "Rendeléskezelés",
        "Vevőkezelés",
        "Korlátlan termékek"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Minden Alapcsomag funkció",
        "Speciális statisztikák",
        "Értesítések",
        "Kiszállítás-kezelés",
        "Több felhasználó",
        "Adatexport"
      ]
    ]
  ],
  "lv": [
    [
      "free",
      "Bezmaksas",
      [
        "Pamata pārvaldība",
        "Dzīvnieku pārvaldība",
        "Olu ražošana",
        "Līdz 5 produktiem"
      ]
    ],
    [
      "essential",
      "Pamata",
      [
        "Visas pārvaldības funkcijas",
        "Tiešsaistes veikals",
        "Pasūtījumu pārvaldība",
        "Klientu pārvaldība",
        "Neierobežoti produkti"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Viss no Pamata",
        "Paplašinātā statistika",
        "Paziņojumi",
        "Piegāžu pārvaldība",
        "Vairāki lietotāji",
        "Datu eksports"
      ]
    ]
  ],
  "lt": [
    [
      "free",
      "Nemokamas",
      [
        "Pagrindiniai valdymo įrankiai",
        "Gyvūnų valdymas",
        "Kiaušinių gamyba",
        "Iki 5 produktų"
      ]
    ],
    [
      "essential",
      "Esminis",
      [
        "Visos valdymo funkcijos",
        "Internetinė parduotuvė",
        "Užsakymų valdymas",
        "Klientų valdymas",
        "Neriboti produktai"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Viskas iš Esminio",
        "Išplėstinė statistika",
        "Pranešimai",
        "Pristatymų valdymas",
        "Keli naudotojai",
        "Duomenų eksportas"
      ]
    ]
  ],
  "pl": [
    [
      "free",
      "Bezpłatny",
      [
        "Podstawowe zarządzanie",
        "Zarządzanie zwierzętami",
        "Produkcja jaj",
        "Do 5 produktów"
      ]
    ],
    [
      "essential",
      "Podstawowy",
      [
        "Wszystkie funkcje zarządzania",
        "Sklep internetowy",
        "Zarządzanie zamówieniami",
        "Zarządzanie klientami",
        "Nielimitowane produkty"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Wszystko z Podstawowego",
        "Zaawansowane statystyki",
        "Powiadomienia",
        "Zarządzanie dostawami",
        "Wielu użytkowników",
        "Eksport danych"
      ]
    ]
  ],
  "pt": [
    [
      "free",
      "Gratuito",
      [
        "Gestão básica",
        "Gestão de animais",
        "Produção de ovos",
        "Até 5 produtos"
      ]
    ],
    [
      "essential",
      "Essencial",
      [
        "Todas as funções de gestão",
        "Loja online",
        "Gestão de encomendas",
        "Gestão de clientes",
        "Produtos ilimitados"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Tudo do Essencial",
        "Estatísticas avançadas",
        "Notificações",
        "Gestão de entregas",
        "Vários utilizadores",
        "Exportação de dados"
      ]
    ]
  ],
  "ro": [
    [
      "free",
      "Gratuit",
      [
        "Gestiune de bază",
        "Gestionarea animalelor",
        "Producție ouă",
        "Până la 5 produse"
      ]
    ],
    [
      "essential",
      "Esențial",
      [
        "Toate funcțiile de gestionare",
        "Magazin online",
        "Gestionarea comenzilor",
        "Gestionarea clienților",
        "Produse nelimitate"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Tot Esențialul",
        "Statistici avansate",
        "Notificări",
        "Gestionarea livrărilor",
        "Mai mulți utilizatori",
        "Export date"
      ]
    ]
  ],
  "sk": [
    [
      "free",
      "Bezplatný",
      [
        "Základná správa",
        "Správa zvierat",
        "Produkcia vajec",
        "Až 5 produktov"
      ]
    ],
    [
      "essential",
      "Základný",
      [
        "Všetky funkcie správy",
        "Online obchod",
        "Správa objednávok",
        "Správa zákazníkov",
        "Neobmedzené produkty"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Všetko zo Základného",
        "Pokročilé štatistiky",
        "Oznámenia",
        "Správa doručení",
        "Viacero používateľov",
        "Export dát"
      ]
    ]
  ],
  "sl": [
    [
      "free",
      "Brezplačno",
      [
        "Osnovno upravljanje",
        "Upravljanje živali",
        "Proizvodnja jajc",
        "Do 5 izdelkov"
      ]
    ],
    [
      "essential",
      "Osnovno",
      [
        "Vse funkcije upravljanja",
        "Spletna trgovina",
        "Upravljanje naročil",
        "Upravljanje strank",
        "Neomejeni izdelki"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Vse iz Osnovno",
        "Napredna statistika",
        "Obvestila",
        "Upravljanje dostav",
        "Več uporabnikov",
        "Izvoz podatkov"
      ]
    ]
  ],
  "cs": [
    [
      "free",
      "Zdarma",
      [
        "Základní správa",
        "Správa zvířat",
        "Produkce vajec",
        "Až 5 produktů"
      ]
    ],
    [
      "essential",
      "Základní",
      [
        "Všechny funkce správy",
        "Online obchod",
        "Správa objednávek",
        "Správa zákazníků",
        "Neomezené produkty"
      ]
    ],
    [
      "pro",
      "Pro",
      [
        "Vše ze Základního",
        "Pokročilé statistiky",
        "Oznámení",
        "Správa doručení",
        "Více uživatelů",
        "Export dat"
      ]
    ]
  ]
};

const faqData = {
  "fr": [
    [
      "Ai-je besoin de compétences en informatique ?",
      "Non, l'application est pensée pour être extrêmement simple et utilisable depuis un smartphone."
    ],
    [
      "Puis-je vendre mes produits en ligne ?",
      "Oui, chaque ferme obtient automatiquement une boutique publique avec un QR Code."
    ],
    [
      "Mes données sont-elles isolées des autres fermes ?",
      "Absolument. Chaque ferme possède ses propres données, totalement isolées."
    ],
    [
      "Puis-je essayer gratuitement ?",
      "Oui, le plan Gratuit est disponible sans engagement."
    ]
  ],
  "en": [
    [
      "Do I need computer skills?",
      "No, the app is designed to be extremely simple and usable from a smartphone."
    ],
    [
      "Can I sell my products online?",
      "Yes, each farm automatically gets a public shop with a QR code."
    ],
    [
      "Is my data isolated from other farms?",
      "Absolutely. Each farm has its own fully isolated data."
    ],
    [
      "Can I try it for free?",
      "Yes, the Free plan is available with no commitment."
    ]
  ],
  "es": [
    [
      "¿Necesito conocimientos de informática?",
      "No, la aplicación es muy sencilla y se usa desde el móvil."
    ],
    [
      "¿Puedo vender mis productos online?",
      "Sí, cada granja obtiene automáticamente una tienda pública con código QR."
    ],
    [
      "¿Mis datos están aislados de otras granjas?",
      "Por supuesto. Cada granja tiene sus propios datos totalmente aislados."
    ],
    [
      "¿Puedo probarlo gratis?",
      "Sí, el plan Gratis está disponible sin compromiso."
    ]
  ],
  "it": [
    [
      "Servono competenze informatiche?",
      "No, l'app è pensata per essere semplicissima e usabile da smartphone."
    ],
    [
      "Posso vendere i miei prodotti online?",
      "Sì, ogni azienda ottiene automaticamente un negozio pubblico con QR Code."
    ],
    [
      "I miei dati sono isolati dalle altre aziende?",
      "Assolutamente. Ogni azienda ha i propri dati totalmente isolati."
    ],
    [
      "Posso provarlo gratis?",
      "Sì, il piano Gratuito è disponibile senza impegno."
    ]
  ],
  "de": [
    [
      "Brauche ich IT-Kenntnisse?",
      "Nein, die App ist sehr einfach und vom Smartphone aus nutzbar."
    ],
    [
      "Kann ich meine Produkte online verkaufen?",
      "Ja, jeder Hof erhält automatisch einen öffentlichen Shop mit QR-Code."
    ],
    [
      "Sind meine Daten von anderen Höfen getrennt?",
      "Absolut. Jeder Hof hat seine eigenen, vollständig isolierten Daten."
    ],
    [
      "Kann ich es kostenlos testen?",
      "Ja, der kostenlose Tarif ist unverbindlich verfügbar."
    ]
  ],
  "nl": [
    [
      "Heb ik informaticakennis nodig?",
      "Nee, de applicatie is ontworpen om uiterst eenvoudig te zijn en bruikbaar vanaf een smartphone."
    ],
    [
      "Kan ik mijn producten online verkopen?",
      "Ja, elke boerderij krijgt automatisch een publieke winkel met een QR-code."
    ],
    [
      "Zijn mijn gegevens gescheiden van andere boerderijen?",
      "Absoluut. Elke boerderij heeft zijn eigen gegevens, volledig gescheiden."
    ],
    [
      "Kan ik gratis uitproberen?",
      "Ja, het Gratis abonnement is beschikbaar zonder verplichting."
    ]
  ],
  "sv": [
    [
      "Behöver jag datorkunskaper?",
      "Nej, appen är utformad för att vara extremt enkel och användbar från en smartphone."
    ],
    [
      "Kan jag sälja mina produkter online?",
      "Ja, varje gård får automatiskt en publik butik med QR-kod."
    ],
    [
      "Är mina data isolerade från andra gårdar?",
      "Absolut. Varje gård har sin egen data, helt isolerad."
    ],
    [
      "Kan jag prova gratis?",
      "Ja, gratisplanen är tillgänglig utan förpliktelser."
    ]
  ],
  "da": [
    [
      "Behøver jeg IT-kompetencer?",
      "Nej, appen er designet til at være ekstremt enkel og brugbar fra en smartphone."
    ],
    [
      "Kan jeg sælge mine produkter online?",
      "Ja, hver gård får automatisk en offentlig butik med en QR-kode."
    ],
    [
      "Er mine data adskilt fra andre gårde?",
      "Absolut. Hver gård har sine egne data, fuldstændigt isoleret."
    ],
    [
      "Kan jeg prøve det gratis?",
      "Ja, den gratis plan er tilgængelig uden forpligtelse."
    ]
  ],
  "bg": [
    [
      "Нужни ли са ми компютърни познания?",
      "Не, приложението е проектирано да бъде изключително лесно и използваемо от смартфон."
    ],
    [
      "Мога ли да продавам продуктите си онлайн?",
      "Да, всяка ферма автоматично получава публичен магазин с QR код."
    ],
    [
      "Данните ми изолирани ли са от другите ферми?",
      "Абсолютно. Всяка ферма има собствени данни, напълно изолирани."
    ],
    [
      "Мога ли да пробвам безплатно?",
      "Да, Безплатният план е достъпен без ангажимент."
    ]
  ],
  "el": [
    [
      "Χρειάζομαι γνώσεις πληροφορικής;",
      "Όχι, η εφαρμογή είναι σχεδιασμένη για να είναι εξαιρετικά απλή και χρησιμοποιείται από smartphone."
    ],
    [
      "Μπορώ να πουλάω τα προϊόντα μου διαδικτυακά;",
      "Ναι, κάθε φάρμα αποκτά αυτόματα ένα δημόσιο κατάστημα με QR Code."
    ],
    [
      "Τα δεδομένα μου είναι απομονωμένα από άλλες φάρμες;",
      "Απολύτως. Κάθε φάρμα έχει τα δικά της δεδομένα, πλήρως απομονωμένα."
    ],
    [
      "Μπορώ να δοκιμάσω δωρεάν;",
      "Ναι, το Δωρεάν πλάνο είναι διαθέσιμο χωρίς δέσμευση."
    ]
  ],
  "hr": [
    [
      "Trebam li informatičke vještine?",
      "Ne, aplikacija je osmišljena da bude iznimno jednostavna i upotrebljiva s pametnog telefona."
    ],
    [
      "Mogu li prodavati svoje proizvode online?",
      "Da, svaka farma automatski dobiva javnu trgovinu s QR kodom."
    ],
    [
      "Jesu li moji podaci odvojeni od ostalih farmi?",
      "Apsolutno. Svaka farma ima vlastite potpuno izolirane podatke."
    ],
    [
      "Mogu li isprobati besplatno?",
      "Da, besplatni plan dostupan je bez obveza."
    ]
  ],
  "et": [
    [
      "Kas vajan IT-oskusi?",
      "Ei, rakendus on loodud olema äärmiselt lihtne ja kasutatav nutitelefonist."
    ],
    [
      "Kas saan oma tooteid veebis müüa?",
      "Jah, iga farm saab automaatselt avaliku poe koos QR-koodiga."
    ],
    [
      "Kas minu andmed on teistest farmidest eraldatud?",
      "Absoluutselt. Igal farmil on oma täielikult eraldatud andmed."
    ],
    [
      "Kas saan tasuta proovida?",
      "Jah, tasuta plaan on saadaval ilma kohustuseta."
    ]
  ],
  "fi": [
    [
      "Tarvitsenko tietotekniikan osaamista?",
      "Ei, sovellus on suunniteltu erittäin yksinkertaiseksi ja käytettäväksi älypuhelimella."
    ],
    [
      "Voinko myydä tuotteitani verkossa?",
      "Kyllä, jokaiselle tilalle luodaan automaattisesti julkinen kauppa QR-koodilla."
    ],
    [
      "Ovatko tietoni erillään muista tiloista?",
      "Ehdottomasti. Jokaisella tilalla on omat tietonsa, täysin eristettyinä."
    ],
    [
      "Voinko kokeilla ilmaiseksi?",
      "Kyllä, ilmainen suunnitelma on saatavilla ilman sitoumuksia."
    ]
  ],
  "hu": [
    [
      "Szükséges informatikai ismeret?",
      "Nem, az alkalmazás rendkívül egyszerű és okostelefonról is használható."
    ],
    [
      "Értékesíthetem termékeimet online?",
      "Igen, minden farm automatikusan kap egy nyilvános boltot QR-kóddal."
    ],
    [
      "Az adataim el vannak különítve a többi farmtól?",
      "Természetesen. Minden farmnak saját, teljesen elkülönített adatai vannak."
    ],
    [
      "Kipróbálhatom ingyen?",
      "Igen, az ingyenes csomag kötelezettség nélkül elérhető."
    ]
  ],
  "lv": [
    [
      "Vai man vajadzīgas datorzinības?",
      "Nē, lietotne ir izstrādāta tā, lai būtu ārkārtīgi vienkārša un lietojama no viedtālruņa."
    ],
    [
      "Vai es varu pārdot savus produktus tiešsaistē?",
      "Jā, katrai saimniecībai automātiski tiek izveidots publisks veikals ar QR kodu."
    ],
    [
      "Vai mani dati ir nošķirti no citām saimniecībām?",
      "Pilnīgi. Katrai saimniecībai ir savi dati, pilnībā izolēti."
    ],
    [
      "Vai es varu izmēģināt bezmaksas?",
      "Jā, bezmaksas plāns ir pieejams bez saistībām."
    ]
  ],
  "lt": [
    [
      "Ar reikia turėti IT žinių?",
      "Ne, programa sukurta būti itin paprasta ir naudojama iš išmaniojo telefono."
    ],
    [
      "Ar galiu parduoti produktus internetu?",
      "Taip, kiekvienas ūkis automatiškai gauna viešąją parduotuvę su QR kodu."
    ],
    [
      "Ar mano duomenys atskirti nuo kitų ūkių?",
      "Absoliučiai. Kiekvienas ūkis turi savo duomenis, visiškai atskirti."
    ],
    [
      "Ar galiu išbandyti nemokamai?",
      "Taip, Nemokamas planas prieinamas be jokių įsipareigojimų."
    ]
  ],
  "pl": [
    [
      "Czy potrzebuję umiejętności informatycznych?",
      "Nie, aplikacja jest zaprojektowana tak, aby była bardzo prosta i wygodna na smartfonie."
    ],
    [
      "Czy mogę sprzedawać produkty online?",
      "Tak, każda farma automatycznie otrzymuje publiczny sklep z kodem QR."
    ],
    [
      "Czy moje dane są odizolowane od innych farm?",
      "Absolutnie. Każda farma ma własne dane, całkowicie odizolowane."
    ],
    [
      "Czy mogę wypróbować bezpłatnie?",
      "Tak, plan Bezpłatny jest dostępny bez zobowiązań."
    ]
  ],
  "pt": [
    [
      "Preciso de conhecimentos informáticos?",
      "Não, a aplicação foi concebida para ser extremamente simples e utilizável a partir de um smartphone."
    ],
    [
      "Posso vender os meus produtos online?",
      "Sim, cada quinta obtém automaticamente uma loja pública com um QR Code."
    ],
    [
      "Os meus dados estão isolados das outras quintas?",
      "Absolutamente. Cada quinta possui os seus próprios dados, totalmente isolados."
    ],
    [
      "Posso experimentar gratuitamente?",
      "Sim, o plano Gratuito está disponível sem compromisso."
    ]
  ],
  "ro": [
    [
      "Am nevoie de cunoștințe de informatică?",
      "Nu, aplicația este concepută să fie extrem de simplă și utilizabilă de pe smartphone."
    ],
    [
      "Pot vinde produsele mele online?",
      "Da, fiecare fermă primește automat un magazin public cu Cod QR."
    ],
    [
      "Datele mele sunt izolate de celelalte ferme?",
      "Absolut. Fiecare fermă are propriile date, complet izolate."
    ],
    [
      "Pot încerca gratuit?",
      "Da, planul Gratuit este disponibil fără angajament."
    ]
  ],
  "sk": [
    [
      "Potrebujem počítačové znalosti?",
      "Nie, aplikácia je navrhnutá tak, aby bola mimoriadne jednoduchá a použiteľná zo smartfónu."
    ],
    [
      "Môžem predávať produkty online?",
      "Áno, každá farma automaticky získa verejný obchod s QR kódom."
    ],
    [
      "Sú moje dáta oddelené od iných fariem?",
      "Rozhodne. Každá farma má vlastné dáta, úplne izolované."
    ],
    [
      "Môžem to vyskúšať zadarmo?",
      "Áno, bezplatný plán je dostupný bez záväzkov."
    ]
  ],
  "sl": [
    [
      "Ali potrebujem računalniško znanje?",
      "Ne, aplikacija je zasnovana tako, da je izjemno preprosta in uporabna na pametnem telefonu."
    ],
    [
      "Ali lahko prodajam svoje izdelke spletno?",
      "Da, vsaka kmetija samodejno dobi javno trgovino s QR kodo."
    ],
    [
      "Ali so moji podatki ločeni od drugih kmetij?",
      "Seveda. Vsaka kmetija ima lastne podatke, ki so popolnoma izolirani."
    ],
    [
      "Ali lahko preskusim brezplačno?",
      "Da, brezplačni plan je na voljo brez obveznosti."
    ]
  ],
  "cs": [
    [
      "Potřebuji znalosti informatiky?",
      "Ne, aplikace je navržena tak, aby byla velmi jednoduchá a použitelná ze smartphonu."
    ],
    [
      "Mohu prodávat své produkty online?",
      "Ano, každá farma automaticky získá veřejný obchod s QR kódem."
    ],
    [
      "Jsou moje data oddělena od ostatních farem?",
      "Rozhodně. Každá farma má vlastní data, zcela izolovaná."
    ],
    [
      "Mohu vyzkoušet zdarma?",
      "Ano, bezplatný plán je k dispozici bez závazků."
    ]
  ]
};

const base = {
  "fr": {
    "nav": {
      "features": "Fonctionnalités",
      "pricing": "Tarifs",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Connexion",
      "createFarm": "Créer ma ferme"
    },
    "hero": {
      "badge": "Le SaaS des petites fermes & élevages",
      "title": "Gérez tous vos élevages simplement, de la ferme à la vente",
      "subtitle": "Poules, canards, lapins, chèvres, moutons, ruches… Suivez vos animaux, votre production, vos stocks, vos commandes et vos clients depuis une seule application.",
      "cta1": "Créer ma ferme gratuitement",
      "cta2": "Découvrir l'application"
    },
    "featuresSection": {
      "title": "Tout pour gérer votre activité",
      "subtitle": "Une plateforme complète, pensée pour les producteurs fermiers."
    },
    "pricing": {
      "title": "Des tarifs simples",
      "subtitle": "Commencez gratuitement, évoluez quand vous le souhaitez.",
      "popular": "Populaire",
      "choose": "Choisir",
      "month": "/mois"
    },
    "faqTitle": "Questions fréquentes",
    "ctaSection": {
      "title": "Prêt à simplifier votre ferme ?",
      "subtitle": "Créez votre ferme en quelques minutes, sans carte bancaire.",
      "button": "Créer ma ferme gratuitement"
    },
    "footer": {
      "made": "Fait avec ❤️ pour les producteurs fermiers.",
      "cgu": "CGU",
      "privacy": "Confidentialité",
      "cookies": "Cookies",
      "contact": "Contact"
    }
  },
  "en": {
    "nav": {
      "features": "Features",
      "pricing": "Pricing",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Log in",
      "createFarm": "Create my farm"
    },
    "hero": {
      "badge": "The SaaS for small farms & breeders",
      "title": "Manage all your livestock simply, from farm to sale",
      "subtitle": "Chickens, ducks, rabbits, goats, sheep, beehives… Track your animals, production, stock, orders and customers from a single app.",
      "cta1": "Create my farm for free",
      "cta2": "Discover the app"
    },
    "featuresSection": {
      "title": "Everything to run your business",
      "subtitle": "A complete platform built for farm producers."
    },
    "pricing": {
      "title": "Simple pricing",
      "subtitle": "Start for free, upgrade whenever you want.",
      "popular": "Popular",
      "choose": "Choose",
      "month": "/mo"
    },
    "faqTitle": "Frequently asked questions",
    "ctaSection": {
      "title": "Ready to simplify your farm?",
      "subtitle": "Create your farm in minutes, no credit card required.",
      "button": "Create my farm for free"
    },
    "footer": {
      "made": "Made with ❤️ for farm producers.",
      "cgu": "Terms",
      "privacy": "Privacy",
      "cookies": "Cookies",
      "contact": "Contact"
    }
  },
  "es": {
    "nav": {
      "features": "Funciones",
      "pricing": "Precios",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Iniciar sesión",
      "createFarm": "Crear mi granja"
    },
    "hero": {
      "badge": "El SaaS para pequeñas granjas y ganaderos",
      "title": "Gestiona todos tus animales de forma sencilla, de la granja a la venta",
      "subtitle": "Gallinas, patos, conejos, cabras, ovejas, colmenas… Sigue tus animales, la producción, el inventario, los pedidos y los clientes desde una sola app.",
      "cta1": "Crear mi granja gratis",
      "cta2": "Descubrir la app"
    },
    "featuresSection": {
      "title": "Todo para gestionar tu actividad",
      "subtitle": "Una plataforma completa pensada para productores."
    },
    "pricing": {
      "title": "Precios sencillos",
      "subtitle": "Empieza gratis, mejora cuando quieras.",
      "popular": "Popular",
      "choose": "Elegir",
      "month": "/mes"
    },
    "faqTitle": "Preguntas frecuentes",
    "ctaSection": {
      "title": "¿Listo para simplificar tu granja?",
      "subtitle": "Crea tu granja en minutos, sin tarjeta de crédito.",
      "button": "Crear mi granja gratis"
    },
    "footer": {
      "made": "Hecho con ❤️ para productores.",
      "cgu": "Términos",
      "privacy": "Privacidad",
      "cookies": "Cookies",
      "contact": "Contacto"
    }
  },
  "it": {
    "nav": {
      "features": "Funzionalità",
      "pricing": "Prezzi",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Accedi",
      "createFarm": "Crea la mia azienda"
    },
    "hero": {
      "badge": "Il SaaS per piccole aziende e allevatori",
      "title": "Gestisci tutti i tuoi allevamenti in modo semplice, dalla fattoria alla vendita",
      "subtitle": "Galline, anatre, conigli, capre, pecore, arnie… Segui i tuoi animali, la produzione, il magazzino, gli ordini e i clienti da una sola app.",
      "cta1": "Crea la mia azienda gratis",
      "cta2": "Scopri l'app"
    },
    "featuresSection": {
      "title": "Tutto per gestire la tua attività",
      "subtitle": "Una piattaforma completa pensata per i produttori."
    },
    "pricing": {
      "title": "Prezzi semplici",
      "subtitle": "Inizia gratis, passa a un piano superiore quando vuoi.",
      "popular": "Popolare",
      "choose": "Scegli",
      "month": "/mese"
    },
    "faqTitle": "Domande frequenti",
    "ctaSection": {
      "title": "Pronto a semplificare la tua azienda?",
      "subtitle": "Crea la tua azienda in pochi minuti, senza carta di credito.",
      "button": "Crea la mia azienda gratis"
    },
    "footer": {
      "made": "Fatto con ❤️ per i produttori.",
      "cgu": "Termini",
      "privacy": "Privacy",
      "cookies": "Cookie",
      "contact": "Contatti"
    }
  },
  "de": {
    "nav": {
      "features": "Funktionen",
      "pricing": "Preise",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Anmelden",
      "createFarm": "Hof erstellen"
    },
    "hero": {
      "badge": "Das SaaS für kleine Höfe & Züchter",
      "title": "Verwalten Sie alle Ihre Tierhaltungen einfach – vom Hof bis zum Verkauf",
      "subtitle": "Hühner, Enten, Kaninchen, Ziegen, Schafe, Bienenstöcke… Verfolgen Sie Ihre Tiere, Produktion, Lager, Bestellungen und Kunden in einer App.",
      "cta1": "Hof kostenlos erstellen",
      "cta2": "App entdecken"
    },
    "featuresSection": {
      "title": "Alles für Ihr Geschäft",
      "subtitle": "Eine komplette Plattform für Hofproduzenten."
    },
    "pricing": {
      "title": "Einfache Preise",
      "subtitle": "Kostenlos starten, jederzeit upgraden.",
      "popular": "Beliebt",
      "choose": "Wählen",
      "month": "/Mon."
    },
    "faqTitle": "Häufige Fragen",
    "ctaSection": {
      "title": "Bereit, Ihren Hof zu vereinfachen?",
      "subtitle": "Erstellen Sie Ihren Hof in Minuten, ohne Kreditkarte.",
      "button": "Hof kostenlos erstellen"
    },
    "footer": {
      "made": "Mit ❤️ für Hofproduzenten gemacht.",
      "cgu": "AGB",
      "privacy": "Datenschutz",
      "cookies": "Cookies",
      "contact": "Kontakt"
    }
  },
  "nl": {
    "nav": {
      "features": "Functies",
      "pricing": "Tarieven",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Inloggen",
      "createFarm": "Mijn boerderij aanmaken"
    },
    "hero": {
      "badge": "De SaaS voor kleine boerderijen & veeteelt",
      "title": "Beheer al uw veeteelt eenvoudig, van boerderij tot verkoop",
      "subtitle": "Kippen, eenden, konijnen, geiten, schapen, bijenkorven… Volg uw dieren, productie, voorraad, bestellingen en klanten vanuit één applicatie.",
      "cta1": "Mijn boerderij gratis aanmaken",
      "cta2": "De applicatie ontdekken"
    },
    "featuresSection": {
      "title": "Alles voor uw bedrijfsbeheer",
      "subtitle": "Een compleet platform, ontworpen voor boerderijproducenten."
    },
    "pricing": {
      "title": "Eenvoudige tarieven",
      "subtitle": "Begin gratis, schakel op wanneer u wilt.",
      "popular": "Populair",
      "choose": "Kiezen",
      "month": "/maand"
    },
    "faqTitle": "Veelgestelde vragen",
    "ctaSection": {
      "title": "Klaar om uw boerderij te vereenvoudigen?",
      "subtitle": "Maak uw boerderij aan in enkele minuten, zonder bankkaart.",
      "button": "Mijn boerderij gratis aanmaken"
    },
    "footer": {
      "made": "Gemaakt met ❤️ voor boerderijproducenten.",
      "cgu": "Gebruiksvoorwaarden",
      "privacy": "Privacy",
      "cookies": "Cookies",
      "contact": "Contact"
    }
  },
  "sv": {
    "nav": {
      "features": "Funktioner",
      "pricing": "Priser",
      "blog": "Blogg",
      "faq": "FAQ",
      "login": "Logga in",
      "createFarm": "Skapa min gård"
    },
    "hero": {
      "badge": "SaaS för små gårdar och djurhållning",
      "title": "Hantera all din djurhållning enkelt, från gård till försäljning",
      "subtitle": "Höns, ankor, kaniner, getter, får, bikupor… Följ dina djur, din produktion, ditt lager, dina beställningar och dina kunder från en enda app.",
      "cta1": "Skapa min gård gratis",
      "cta2": "Utforska appen"
    },
    "featuresSection": {
      "title": "Allt för att hantera din verksamhet",
      "subtitle": "En komplett plattform, skapad för gårdsproducenter."
    },
    "pricing": {
      "title": "Enkla priser",
      "subtitle": "Börja gratis, uppgradera när du vill.",
      "popular": "Populär",
      "choose": "Välj",
      "month": "/månad"
    },
    "faqTitle": "Vanliga frågor",
    "ctaSection": {
      "title": "Redo att förenkla din gård?",
      "subtitle": "Skapa din gård på några minuter, utan kreditkort.",
      "button": "Skapa min gård gratis"
    },
    "footer": {
      "made": "Gjord med ❤️ för gårdsproducenter.",
      "cgu": "Användarvillkor",
      "privacy": "Integritet",
      "cookies": "Cookies",
      "contact": "Kontakt"
    }
  },
  "da": {
    "nav": {
      "features": "Funktioner",
      "pricing": "Priser",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Log ind",
      "createFarm": "Opret min gård"
    },
    "hero": {
      "badge": "SaaS til små gårde & besætninger",
      "title": "Administrer alle dine besætninger nemt – fra gård til salg",
      "subtitle": "Høns, ænder, kaniner, geder, får, bistader… Følg dine dyr, din produktion, dine lagre, dine ordrer og dine kunder fra én enkelt app.",
      "cta1": "Opret min gård gratis",
      "cta2": "Udforsk appen"
    },
    "featuresSection": {
      "title": "Alt til at drive din virksomhed",
      "subtitle": "En komplet platform, skabt til landbrugere."
    },
    "pricing": {
      "title": "Enkle priser",
      "subtitle": "Start gratis, opgrader når du vil.",
      "popular": "Populær",
      "choose": "Vælg",
      "month": "/md."
    },
    "faqTitle": "Ofte stillede spørgsmål",
    "ctaSection": {
      "title": "Klar til at forenkle din gård?",
      "subtitle": "Opret din gård på få minutter, uden betalingskort.",
      "button": "Opret min gård gratis"
    },
    "footer": {
      "made": "Lavet med ❤️ til landbrugere.",
      "cgu": "Vilkår",
      "privacy": "Fortrolighed",
      "cookies": "Cookies",
      "contact": "Kontakt"
    }
  },
  "bg": {
    "nav": {
      "features": "Функции",
      "pricing": "Цени",
      "blog": "Блог",
      "faq": "ЧЗВ",
      "login": "Вход",
      "createFarm": "Създай моята ферма"
    },
    "hero": {
      "badge": "SaaS за малки ферми & животновъди",
      "title": "Управлявайте животновъдството си лесно, от фермата до продажбата",
      "subtitle": "Кокошки, патици, зайци, кози, овце, кошери… Следете животните, производството, запасите, поръчките и клиентите от едно приложение.",
      "cta1": "Създай фермата ми безплатно",
      "cta2": "Разгледай приложението"
    },
    "featuresSection": {
      "title": "Всичко за управление на дейността ви",
      "subtitle": "Пълна платформа, създадена за фермери."
    },
    "pricing": {
      "title": "Прости цени",
      "subtitle": "Започнете безплатно, надградете когато искате.",
      "popular": "Популярен",
      "choose": "Изберете",
      "month": "/месец"
    },
    "faqTitle": "Често задавани въпроси",
    "ctaSection": {
      "title": "Готови ли сте да опростите управлението на фермата?",
      "subtitle": "Създайте фермата си за минути, без кредитна карта.",
      "button": "Създай фермата ми безплатно"
    },
    "footer": {
      "made": "Направено с ❤️ за фермерите.",
      "cgu": "Общи условия",
      "privacy": "Поверителност",
      "cookies": "Бисквитки",
      "contact": "Контакт"
    }
  },
  "el": {
    "nav": {
      "features": "Λειτουργίες",
      "pricing": "Τιμολόγηση",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Σύνδεση",
      "createFarm": "Δημιουργία φάρμας"
    },
    "hero": {
      "badge": "Το SaaS για μικρές φάρμες & εκτροφές",
      "title": "Διαχειριστείτε όλες τις εκτροφές σας εύκολα, από τη φάρμα ως την πώληση",
      "subtitle": "Κότες, πάπιες, κουνέλια, κατσίκες, πρόβατα, κυψέλες… Παρακολουθήστε τα ζώα, την παραγωγή, τα αποθέματα, τις παραγγελίες και τους πελάτες σας από μία εφαρμογή.",
      "cta1": "Δημιουργία φάρμας δωρεάν",
      "cta2": "Ανακαλύψτε την εφαρμογή"
    },
    "featuresSection": {
      "title": "Όλα για τη διαχείριση της δραστηριότητάς σας",
      "subtitle": "Μια ολοκληρωμένη πλατφόρμα, σχεδιασμένη για αγρότες παραγωγούς."
    },
    "pricing": {
      "title": "Απλές τιμές",
      "subtitle": "Ξεκινήστε δωρεάν, αναβαθμιστείτε όποτε θέλετε.",
      "popular": "Δημοφιλές",
      "choose": "Επιλογή",
      "month": "/μήνα"
    },
    "faqTitle": "Συχνές ερωτήσεις",
    "ctaSection": {
      "title": "Έτοιμοι να απλοποιήσετε τη φάρμα σας;",
      "subtitle": "Δημιουργήστε τη φάρμα σας σε λίγα λεπτά, χωρίς πιστωτική κάρτα.",
      "button": "Δημιουργία φάρμας δωρεάν"
    },
    "footer": {
      "made": "Φτιαγμένο με ❤️ για τους αγρότες παραγωγούς.",
      "cgu": "ΓΟΣ",
      "privacy": "Απόρρητο",
      "cookies": "Cookies",
      "contact": "Επικοινωνία"
    }
  },
  "hr": {
    "nav": {
      "features": "Značajke",
      "pricing": "Cijene",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Prijava",
      "createFarm": "Stvori moju farmu"
    },
    "hero": {
      "badge": "SaaS za male farme i uzgajivače",
      "title": "Upravljajte svim uzgojima jednostavno, od farme do prodaje",
      "subtitle": "Kokoši, patke, kunići, koze, ovce, košnice… Pratite životinje, proizvodnju, zalihe, narudžbe i kupce iz jedne aplikacije.",
      "cta1": "Stvori farmu besplatno",
      "cta2": "Otkrij aplikaciju"
    },
    "featuresSection": {
      "title": "Sve za upravljanje vašom djelatnošću",
      "subtitle": "Potpuna platforma namijenjena farmerima."
    },
    "pricing": {
      "title": "Jednostavne cijene",
      "subtitle": "Počnite besplatno, napredujte kada želite.",
      "popular": "Popularno",
      "choose": "Odaberi",
      "month": "/mjes."
    },
    "faqTitle": "Česta pitanja",
    "ctaSection": {
      "title": "Spremni za jednostavniju farmu?",
      "subtitle": "Stvorite svoju farmu za nekoliko minuta, bez kreditne kartice.",
      "button": "Stvori farmu besplatno"
    },
    "footer": {
      "made": "Napravljeno s ❤️ za farmere.",
      "cgu": "Uvjeti",
      "privacy": "Privatnost",
      "cookies": "Kolačići",
      "contact": "Kontakt"
    }
  },
  "et": {
    "nav": {
      "features": "Funktsioonid",
      "pricing": "Hinnad",
      "blog": "Blogi",
      "faq": "KKK",
      "login": "Logi sisse",
      "createFarm": "Loo minu farm"
    },
    "hero": {
      "badge": "Väikefarmide ja kasvatuste SaaS",
      "title": "Hallake kõiki kasvatusi lihtsalt, farmist müügini",
      "subtitle": "Kanad, pardid, küülikud, kitsed, lambad, mesilaspered… Jälgige loomi, toodangut, laovarusid, tellimusi ja kliente ühest rakendusest.",
      "cta1": "Loo oma farm tasuta",
      "cta2": "Avasta rakendust"
    },
    "featuresSection": {
      "title": "Kõik tegevuse juhtimiseks",
      "subtitle": "Täielik platvorm, loodud põllumajandustootjatele."
    },
    "pricing": {
      "title": "Lihtsad hinnad",
      "subtitle": "Alustage tasuta, uuendage soovi korral.",
      "popular": "Populaarne",
      "choose": "Vali",
      "month": "/kuu"
    },
    "faqTitle": "Korduma kippuvad küsimused",
    "ctaSection": {
      "title": "Valmis oma farmi lihtsustama?",
      "subtitle": "Looge oma farm mõne minutiga, ilma pangakaardita.",
      "button": "Loo oma farm tasuta"
    },
    "footer": {
      "made": "Valmistatud ❤️-ga põllumajandustootjatele.",
      "cgu": "Kasutustingimused",
      "privacy": "Privaatsus",
      "cookies": "Küpsised",
      "contact": "Kontakt"
    }
  },
  "fi": {
    "nav": {
      "features": "Ominaisuudet",
      "pricing": "Hinnoittelu",
      "blog": "Blogi",
      "faq": "UKK",
      "login": "Kirjaudu",
      "createFarm": "Luo tilani"
    },
    "hero": {
      "badge": "SaaS pienille tiloille & kasvattajille",
      "title": "Hallitse kaikkia eläimiäsi helposti, tilalta myyntiin",
      "subtitle": "Kanat, ankat, kanit, vuohet, lampaat, mehiläispesät… Seuraa eläimiäsi, tuotantoasi, varastojasi, tilauksiasi ja asiakkaitasi yhdestä sovelluksesta.",
      "cta1": "Luo tilani ilmaiseksi",
      "cta2": "Tutustu sovellukseen"
    },
    "featuresSection": {
      "title": "Kaikki toimintasi hallintaan",
      "subtitle": "Täydellinen alusta maataloustuottajille."
    },
    "pricing": {
      "title": "Selkeä hinnoittelu",
      "subtitle": "Aloita ilmaiseksi, kehity kun haluat.",
      "popular": "Suosittu",
      "choose": "Valitse",
      "month": "/kk"
    },
    "faqTitle": "Usein kysytyt kysymykset",
    "ctaSection": {
      "title": "Valmis yksinkertaistamaan tilaasi?",
      "subtitle": "Luo tilasi muutamassa minuutissa, ilman luottokorttia.",
      "button": "Luo tilani ilmaiseksi"
    },
    "footer": {
      "made": "Tehty ❤️ maataloustuottajille.",
      "cgu": "Käyttöehdot",
      "privacy": "Tietosuoja",
      "cookies": "Evästeet",
      "contact": "Yhteystiedot"
    }
  },
  "hu": {
    "nav": {
      "features": "Funkciók",
      "pricing": "Árak",
      "blog": "Blog",
      "faq": "GYIK",
      "login": "Bejelentkezés",
      "createFarm": "Farm létrehozása"
    },
    "hero": {
      "badge": "A kis farmok és tenyészetek SaaS megoldása",
      "title": "Kezelje összes tenyészetét egyszerűen, a farmtól az értékesítésig",
      "subtitle": "Tyúkok, kacsák, nyulak, kecskék, juhok, méhkasok… Kövesse nyomon állatait, termelését, készleteit, rendeléseit és vevőit egyetlen alkalmazásból.",
      "cta1": "Farm létrehozása ingyen",
      "cta2": "Az alkalmazás felfedezése"
    },
    "featuresSection": {
      "title": "Minden a tevékenysége kezeléséhez",
      "subtitle": "Teljes körű platform, gazdálkodóknak tervezve."
    },
    "pricing": {
      "title": "Egyszerű árak",
      "subtitle": "Kezdje ingyen, fejlődjön amikor szeretne.",
      "popular": "Népszerű",
      "choose": "Kiválasztás",
      "month": "/hó"
    },
    "faqTitle": "Gyakran ismételt kérdések",
    "ctaSection": {
      "title": "Készen áll farmja egyszerűsítésére?",
      "subtitle": "Hozza létre farmját néhány perc alatt, bankkártya nélkül.",
      "button": "Farm létrehozása ingyen"
    },
    "footer": {
      "made": "Készült ❤️ gazdálkodóknak.",
      "cgu": "ÁSZF",
      "privacy": "Adatvédelem",
      "cookies": "Sütik",
      "contact": "Kapcsolat"
    }
  },
  "lv": {
    "nav": {
      "features": "Funkcijas",
      "pricing": "Cenas",
      "blog": "Blogs",
      "faq": "BUJ",
      "login": "Pieslēgties",
      "createFarm": "Izveidot manu saimniecību"
    },
    "hero": {
      "badge": "SaaS mazajām saimniecībām un audzētājiem",
      "title": "Pārvaldiet visus savus dzīvniekus vienkārši, no saimniecības līdz pārdošanai",
      "subtitle": "Vistas, pīles, truši, kazas, aitas, stropus… Sekojiet saviem dzīvniekiem, ražošanai, krājumiem, pasūtījumiem un klientiem no vienas lietotnes.",
      "cta1": "Izveidot saimniecību bez maksas",
      "cta2": "Apskatīt lietotni"
    },
    "featuresSection": {
      "title": "Viss jūsu darbības pārvaldībai",
      "subtitle": "Pilnīga platforma, veidota saimniecības ražotājiem."
    },
    "pricing": {
      "title": "Vienkāršas cenas",
      "subtitle": "Sāciet bez maksas, attīstieties pēc vajadzības.",
      "popular": "Populārs",
      "choose": "Izvēlēties",
      "month": "/mēnesī"
    },
    "faqTitle": "Biežāk uzdotie jautājumi",
    "ctaSection": {
      "title": "Gatavs vienkāršot savu saimniecību?",
      "subtitle": "Izveidojiet saimniecību dažās minūtēs, bez bankas kartes.",
      "button": "Izveidot saimniecību bez maksas"
    },
    "footer": {
      "made": "Veidots ar ❤️ saimniecības ražotājiem.",
      "cgu": "Lietošanas noteikumi",
      "privacy": "Privātums",
      "cookies": "Sīkdatnes",
      "contact": "Kontakts"
    }
  },
  "lt": {
    "nav": {
      "features": "Funkcijos",
      "pricing": "Kainos",
      "blog": "Blogas",
      "faq": "DUK",
      "login": "Prisijungti",
      "createFarm": "Sukurti mano ūkį"
    },
    "hero": {
      "badge": "SaaS mažiems ūkiams ir augintojams",
      "title": "Valdykite visus savo ūkius paprastai – nuo ūkio iki pardavimo",
      "subtitle": "Vištos, antys, triušiai, ožkos, avys, aviliai… Sekite gyvūnus, produkciją, atsargas, užsakymus ir klientus iš vienos programos.",
      "cta1": "Sukurti ūkį nemokamai",
      "cta2": "Sužinoti daugiau apie programą"
    },
    "featuresSection": {
      "title": "Viskas jūsų veiklai valdyti",
      "subtitle": "Išsami platforma, sukurta ūkio gamintojams."
    },
    "pricing": {
      "title": "Paprasta kainodara",
      "subtitle": "Pradėkite nemokamai, tobulinkite kada norite.",
      "popular": "Populiarus",
      "choose": "Pasirinkti",
      "month": "/mėn."
    },
    "faqTitle": "Dažniausiai užduodami klausimai",
    "ctaSection": {
      "title": "Pasiruošę supaprastinti savo ūkį?",
      "subtitle": "Sukurkite savo ūkį per kelias minutes, be banko kortelės.",
      "button": "Sukurti ūkį nemokamai"
    },
    "footer": {
      "made": "Sukurta su ❤️ ūkio gamintojams.",
      "cgu": "Naudojimo sąlygos",
      "privacy": "Privatumas",
      "cookies": "Slapukai",
      "contact": "Kontaktai"
    }
  },
  "pl": {
    "nav": {
      "features": "Funkcje",
      "pricing": "Cennik",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Logowanie",
      "createFarm": "Utwórz moją farmę"
    },
    "hero": {
      "badge": "SaaS dla małych farm i hodowli",
      "title": "Zarządzaj swoimi hodowlami prosto, od farmy po sprzedaż",
      "subtitle": "Kury, kaczki, króliki, kozy, owce, ule… Śledź zwierzęta, produkcję, zapasy, zamówienia i klientów z jednej aplikacji.",
      "cta1": "Utwórz farmę bezpłatnie",
      "cta2": "Odkryj aplikację"
    },
    "featuresSection": {
      "title": "Wszystko do zarządzania działalnością",
      "subtitle": "Kompletna platforma stworzona dla rolników."
    },
    "pricing": {
      "title": "Prosta cennik",
      "subtitle": "Zacznij bezpłatnie, rozwijaj się kiedy chcesz.",
      "popular": "Popularny",
      "choose": "Wybierz",
      "month": "/mies."
    },
    "faqTitle": "Często zadawane pytania",
    "ctaSection": {
      "title": "Gotowy uprościć zarządzanie farmą?",
      "subtitle": "Utwórz swoją farmę w kilka minut, bez karty kredytowej.",
      "button": "Utwórz farmę bezpłatnie"
    },
    "footer": {
      "made": "Zrobione z ❤️ dla rolników.",
      "cgu": "Regulamin",
      "privacy": "Prywatność",
      "cookies": "Cookies",
      "contact": "Kontakt"
    }
  },
  "pt": {
    "nav": {
      "features": "Funcionalidades",
      "pricing": "Preços",
      "blog": "Blogue",
      "faq": "FAQ",
      "login": "Entrar",
      "createFarm": "Criar a minha quinta"
    },
    "hero": {
      "badge": "O SaaS das pequenas quintas & criações",
      "title": "Gira todas as suas criações simplesmente, da quinta à venda",
      "subtitle": "Galinhas, patos, coelhos, cabras, ovelhas, colmeias… Acompanhe os seus animais, a sua produção, os seus stocks, as suas encomendas e os seus clientes numa única aplicação.",
      "cta1": "Criar a minha quinta gratuitamente",
      "cta2": "Descobrir a aplicação"
    },
    "featuresSection": {
      "title": "Tudo para gerir a sua atividade",
      "subtitle": "Uma plataforma completa, pensada para os produtores agrícolas."
    },
    "pricing": {
      "title": "Preços simples",
      "subtitle": "Comece gratuitamente, evolua quando quiser.",
      "popular": "Popular",
      "choose": "Escolher",
      "month": "/mês"
    },
    "faqTitle": "Perguntas frequentes",
    "ctaSection": {
      "title": "Pronto para simplificar a sua quinta?",
      "subtitle": "Crie a sua quinta em poucos minutos, sem cartão bancário.",
      "button": "Criar a minha quinta gratuitamente"
    },
    "footer": {
      "made": "Feito com ❤️ para os produtores agrícolas.",
      "cgu": "CGU",
      "privacy": "Privacidade",
      "cookies": "Cookies",
      "contact": "Contacto"
    }
  },
  "ro": {
    "nav": {
      "features": "Funcționalități",
      "pricing": "Tarife",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Conectare",
      "createFarm": "Creează ferma mea"
    },
    "hero": {
      "badge": "SaaS-ul fermelor mici & crescătoriilor",
      "title": "Gestionați toate crescătoriile simplu, de la fermă la vânzare",
      "subtitle": "Găini, rațe, iepuri, capre, oi, stupi… Urmăriți animalele, producția, stocurile, comenzile și clienții dintr-o singură aplicație.",
      "cta1": "Creează ferma mea gratuit",
      "cta2": "Descoperă aplicația"
    },
    "featuresSection": {
      "title": "Tot ce aveți nevoie pentru a gestiona activitatea",
      "subtitle": "O platformă completă, gândită pentru producătorii fermieri."
    },
    "pricing": {
      "title": "Tarife simple",
      "subtitle": "Începeți gratuit, evoluați când doriți.",
      "popular": "Popular",
      "choose": "Alegeți",
      "month": "/lună"
    },
    "faqTitle": "Întrebări frecvente",
    "ctaSection": {
      "title": "Gata să simplificați ferma?",
      "subtitle": "Creați ferma în câteva minute, fără card bancar.",
      "button": "Creează ferma mea gratuit"
    },
    "footer": {
      "made": "Făcut cu ❤️ pentru producătorii fermieri.",
      "cgu": "T&C",
      "privacy": "Confidențialitate",
      "cookies": "Cookies",
      "contact": "Contact"
    }
  },
  "sk": {
    "nav": {
      "features": "Funkcie",
      "pricing": "Cenník",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Prihlásenie",
      "createFarm": "Vytvoriť moju farmu"
    },
    "hero": {
      "badge": "SaaS pre malé farmy & chovy",
      "title": "Spravujte všetky chovy jednoducho, od farmy po predaj",
      "subtitle": "Sliepky, kačky, králiky, kozy, ovce, úľe… Sledujte zvieratá, produkciu, sklady, objednávky a zákazníkov z jednej aplikácie.",
      "cta1": "Vytvoriť farmu zadarmo",
      "cta2": "Objaviť aplikáciu"
    },
    "featuresSection": {
      "title": "Všetko pre správu vašej činnosti",
      "subtitle": "Kompletná platforma navrhnutá pre farmárov."
    },
    "pricing": {
      "title": "Jednoduché ceny",
      "subtitle": "Začnite zadarmo, rozšírte sa kedy chcete.",
      "popular": "Obľúbený",
      "choose": "Vybrať",
      "month": "/mesiac"
    },
    "faqTitle": "Často kladené otázky",
    "ctaSection": {
      "title": "Pripravení zjednodušiť vašu farmu?",
      "subtitle": "Vytvorte farmu za pár minút, bez platobnej karty.",
      "button": "Vytvoriť farmu zadarmo"
    },
    "footer": {
      "made": "Vytvorené s ❤️ pre farmárov.",
      "cgu": "VOP",
      "privacy": "Ochrana súkromia",
      "cookies": "Cookies",
      "contact": "Kontakt"
    }
  },
  "sl": {
    "nav": {
      "features": "Funkcionalnosti",
      "pricing": "Cenik",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Prijava",
      "createFarm": "Ustvari mojo kmetijo"
    },
    "hero": {
      "badge": "SaaS za male kmetije in reje",
      "title": "Upravljajte vse svoje reje preprosto, od kmetije do prodaje",
      "subtitle": "Kokoši, race, zajci, koze, ovce, čebele… Sledite živalim, proizvodnji, zalogam, naročilom in strankam v eni aplikaciji.",
      "cta1": "Ustvarite kmetijo brezplačno",
      "cta2": "Odkrijte aplikacijo"
    },
    "featuresSection": {
      "title": "Vse za upravljanje vaše dejavnosti",
      "subtitle": "Celovita platforma, zasnovana za kmete."
    },
    "pricing": {
      "title": "Preprosta cenovna politika",
      "subtitle": "Začnite brezplačno, nadgradite kadarkoli.",
      "popular": "Priljubljeno",
      "choose": "Izberi",
      "month": "/mesec"
    },
    "faqTitle": "Pogosta vprašanja",
    "ctaSection": {
      "title": "Pripravljeni poenostaviti svojo kmetijo?",
      "subtitle": "Ustvarite kmetijo v nekaj minutah, brez bančne kartice.",
      "button": "Ustvarite kmetijo brezplačno"
    },
    "footer": {
      "made": "Narejeno z ❤️ za kmete.",
      "cgu": "Pogoji uporabe",
      "privacy": "Zasebnost",
      "cookies": "Piškotki",
      "contact": "Kontakt"
    }
  },
  "cs": {
    "nav": {
      "features": "Funkce",
      "pricing": "Ceník",
      "blog": "Blog",
      "faq": "FAQ",
      "login": "Přihlášení",
      "createFarm": "Vytvořit moji farmu"
    },
    "hero": {
      "badge": "SaaS pro malé farmy & chovy",
      "title": "Spravujte všechny své chovy jednoduše, od farmy po prodej",
      "subtitle": "Slepice, kachny, králíci, kozy, ovce, úly… Sledujte svá zvířata, produkci, sklady, objednávky a zákazníky z jediné aplikace.",
      "cta1": "Vytvořit moji farmu zdarma",
      "cta2": "Prozkoumat aplikaci"
    },
    "featuresSection": {
      "title": "Vše pro řízení vaší činnosti",
      "subtitle": "Kompletní platforma navržená pro farmářské producenty."
    },
    "pricing": {
      "title": "Jednoduché ceny",
      "subtitle": "Začněte zdarma, rozšiřte kdykoliv chcete.",
      "popular": "Oblíbený",
      "choose": "Vybrat",
      "month": "/měsíc"
    },
    "faqTitle": "Často kladené otázky",
    "ctaSection": {
      "title": "Připraveni zjednodušit vaši farmu?",
      "subtitle": "Vytvořte svou farmu během několika minut, bez platební karty.",
      "button": "Vytvořit moji farmu zdarma"
    },
    "footer": {
      "made": "Vytvořeno s ❤️ pro farmářské producenty.",
      "cgu": "Podmínky",
      "privacy": "Ochrana soukromí",
      "cookies": "Cookies",
      "contact": "Kontakt"
    }
  }
};

export const translations = {};
SUPPORTED.forEach((code) => {
  translations[code] = {
    ...base[code],
    navItems: navKeys[code],
    features: featuresData[code].map(([t, d]) => ({ t, d })),
    plans: plansData[code].map(([key, name, features]) => ({ key, name, features })),
    faq: faqData[code].map(([q, a]) => ({ q, a })),
  };
});
